import React from 'react'
import '../../Styles/genelife.css';
import APP_ENV from "../../Environment";
import * as PropTypes from "prop-types";

export class RakutenLogin extends React.Component {
  render() {
    const open_id_connect_url = `${APP_ENV.USERPOOLDOMEIN}/oauth2/authorize?identity_provider=Rakuten&redirect_uri=${APP_ENV.FRONT_URL}/oauth&response_type=code&client_id=${APP_ENV.USERPOOLWEBCLIENTID}&scope=openid+profile`;
    return (<div className="fieldwrap loginbox">
      <h2 className="fieldtitle">楽天IDでのログインについて</h2>
      楽天IDでのログイン機能につきましては、2021年10月31日をもって終了となりました。今後は、同画面上部にある「遺伝子検査」をクリックしてメールアドレスとパスワードをご入力の上、ログインをお願いいたします。
    </div>)
  }
}
RakutenLogin.propTypes = {
  normalChecked: PropTypes.bool
};

export default RakutenLogin;
